import { createBrowserParentAccessPersistence } from "./browserPersistence";
import { LocalParentAccessStore } from "./LocalParentAccessStore";

export const parentAccessStore = new LocalParentAccessStore(
  createBrowserParentAccessPersistence()
);
